var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('b-card', {
    attrs: {
      "header": "<i class='fa fa-align-justify'></i> List Pengajuan Izin"
    }
  }, [(_vm.isLoading) ? _c('div', {
    staticClass: "d-flex align-items-center justify-content-center",
    staticStyle: {
      "height": "20rem"
    }
  }, [_c('half-circle-spinner', {
    attrs: {
      "animation-duration": 1000,
      "size": 60,
      "color": '#000000'
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.isLoading) ? _c('div', {}, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "p-3 pull-right"
  }, [_c('router-link', {
    staticClass: "btn btn-success ",
    attrs: {
      "to": '/pengajuanftz/addheader',
      "title": "Rekam permohonan izin"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Add New")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-12",
    staticStyle: {
      "overflow-y": "scroll"
    }
  }, [_c('table', {
    staticClass: "table table-bordered"
  }, [_c('thead', [_c('tr', {
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('th', {
    on: {
      "click": function($event) {
        _vm.sort('NM_PERUSAHAAN')
      }
    }
  }, [_vm._v("Nama Perusahaan "), _c('i', {
    staticClass: "fa fa-arrows-v pull-right"
  })]), _vm._v(" "), _c('th', {
    on: {
      "click": function($event) {
        _vm.sort('no_mohon')
      }
    }
  }, [_vm._v("No Mohon "), _c('i', {
    staticClass: "fa fa-arrows-v pull-right"
  })]), _vm._v(" "), _c('th', {
    on: {
      "click": function($event) {
        _vm.sort('tgl_mohon')
      }
    }
  }, [_vm._v("Tgl Mohon "), _c('i', {
    staticClass: "fa fa-arrows-v pull-right"
  })]), _vm._v(" "), _c('th', {
    on: {
      "click": function($event) {
        _vm.sort('nama_ijin')
      }
    }
  }, [_vm._v("Jenis Izin"), _c('i', {
    staticClass: "fa fa-arrows-v pull-right"
  })]), _vm._v(" "), _c('th', {
    on: {
      "click": function($event) {
        _vm.sort('status')
      }
    }
  }, [_vm._v("Status"), _c('i', {
    staticClass: "fa fa-arrows-v pull-right"
  })]), _vm._v(" "), _c('th')])]), _vm._v(" "), _c('tbody', _vm._l((_vm.pageOfItems), function(bl) {
    return _c('tr', {
      key: bl.id_rekon_manifes
    }, [_c('td', [_vm._v(_vm._s(bl.NM_PERUSAHAAN))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(bl.no_mohon))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(bl.tgl_mohon))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(bl.nama_ijin))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(bl.ur_status))]), _vm._v(" "), _c('td', [_c('router-link', {
      staticClass: "btn btn-primary",
      attrs: {
        "to": '/pengajuanftz/detilheader/' + bl.id_permohonan,
        "title": "Detil Pengajuan"
      }
    }, [_c('i', {
      staticClass: "fa fa-search"
    })]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-danger",
      attrs: {
        "title": "Hapus Pengajuan"
      },
      on: {
        "click": function($event) {
          _vm.confir(bl.id_permohonan)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash-o"
    })])], 1)])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "ml-3 pb-0 pt-3"
  }, [_c('jw-pagination', {
    attrs: {
      "items": _vm.filteredData
    },
    on: {
      "changePage": _vm.onChangePage
    }
  })], 1)]) : _vm._e()])], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a4d848e","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Pengajuan/PengajuanFtz.vue
// module id = 306
// module chunks = 0